import './../styles/user-details.scss';

export default /* @ngInject */ class {
    constructor(userGroup) {
        this.userGroup = userGroup;
    }
}



// WEBPACK FOOTER //
// ./user/manage-plan/manage-plan-ctrl.js